import { useEffect, useState } from 'react'
import { JSONFetcher } from '../../helpers/json_fetcher'
import { UseJsonApiState } from './types'

/**
 * @desc Hook to use JSON APIs, e.g. api_v4. Changing the passed URL automatically triggers new requests and data updates.
 */
export const useJsonApi = <T,>(url: string): UseJsonApiState<T> => {
  const [data, setData] = useState<T | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    url &&
      JSONFetcher.load({
        url,
        success: (data: T) => {
          setData(data)
          setLoading(false)
        },
      })
  }, [url])

  return { data, loading }
}
